var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAudioPlay(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "43px",
    viewBox: "0 0 58 43",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Icon/Audio") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    opacity: 0.648390997,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Individual-Entry-Media-Field/Desktop",
    transform: "translate(-912.000000, -1167.000000)",
    stroke: "#FFFFFF",
    strokeWidth: 3
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon/Audio",
    transform: "translate(914.000000, 1169.000000)"
  }, /*#__PURE__*/React.createElement("line", {
    x1: 0.288690834,
    y1: 13.2797784,
    x2: 0.288690834,
    y2: 26.5595567,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 6.35119835,
    y1: 6.63988919,
    x2: 6.35119835,
    y2: 32.9107551,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 12.125015,
    y1: 2.876106e-14,
    x2: 12.125015,
    y2: 38.9732626,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 18.1875226,
    y1: 4.61905335,
    x2: 18.1875226,
    y2: 34.3542093,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 23.9613392,
    y1: 9.81548836,
    x2: 23.9613392,
    y2: 28.8690834,
    id: "Line-2"
  }), /*#__PURE__*/React.createElement("line", {
    x1: 30.0238468,
    y1: 13.2797784,
    x2: 30.0238468,
    y2: 26.5595567,
    id: "Line-2",
    transform: "translate(30.023847, 19.919668) scale(-1, 1) translate(-30.023847, -19.919668) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 35.7976634,
    y1: 6.63988919,
    x2: 35.7976634,
    y2: 32.9107551,
    id: "Line-2",
    transform: "translate(35.797663, 19.775322) scale(-1, 1) translate(-35.797663, -19.775322) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 41.860171,
    y1: 2.876106e-14,
    x2: 41.860171,
    y2: 38.9732626,
    id: "Line-2",
    transform: "translate(41.860171, 19.486631) scale(-1, 1) translate(-41.860171, -19.486631) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 47.6339876,
    y1: 4.61905335,
    x2: 47.6339876,
    y2: 34.3542093,
    id: "Line-2",
    transform: "translate(47.633988, 19.486631) scale(-1, 1) translate(-47.633988, -19.486631) "
  }), /*#__PURE__*/React.createElement("line", {
    x1: 53.6964952,
    y1: 9.81548836,
    x2: 53.6964952,
    y2: 28.8690834,
    id: "Line-2",
    transform: "translate(53.696495, 19.342286) scale(-1, 1) translate(-53.696495, -19.342286) "
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioPlay);
export default __webpack_public_path__ + "static/media/AudioPlay.8d0ced5797b0e8fd7bb06362371d9708.svg";
export { ForwardRef as ReactComponent };